import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tbody, Td, Tr, RowSelectVariant } from '@patternfly/react-table';
import { Skeleton } from '@patternfly/react-core';
const SkeletonTableBody = ({ rowsCount = 5, ouiaId = 'SkeletonTableBody', isSelectable, isExpandable, selectVariant = RowSelectVariant.checkbox, columnsCount, }) => {
    const bodyRows = [...Array(rowsCount)].map((_, rowIndex) => (_jsxs(Tr, { ouiaId: `${ouiaId}-tr-${rowIndex}`, children: [isExpandable && (_jsx(Td, { "data-ouia-component-id": `${ouiaId}-td-expand-${rowIndex}`, expand: {
                    rowIndex,
                    isExpanded: false
                } })), isSelectable && (_jsx(Td, { "data-ouia-component-id": `${ouiaId}-td-select-${rowIndex}`, select: {
                    rowIndex,
                    isSelected: false,
                    isDisabled: true,
                    variant: selectVariant
                } })), [...Array(columnsCount)].map((_, colIndex) => (_jsx(Td, { "data-ouia-component-id": `${ouiaId}-td-${rowIndex}-${colIndex}`, children: _jsx(Skeleton, {}) }, colIndex)))] }, rowIndex)));
    return (_jsx(Tbody, { "data-ouia-component-id": `${ouiaId}-tbody`, children: bodyRows }));
};
export default SkeletonTableBody;
